import React from 'react';

import DashboardLayout from '../layouts/Dashboard/Dashboard';

import Legal from '../components/Legal/Legal';
import { notifications } from '../components/Dashboard/testData';
import CustomerDataProvider from '../contexts/CustomerDataProvider';
import {setPageTitle} from '../utils/helpers';

const LegalPageContainer = () => {
  setPageTitle('Legal | Investec Save');

  return (
    <CustomerDataProvider>
      <DashboardLayout notifications={notifications} className="legal-page">
        <Legal />
      </DashboardLayout>
    </CustomerDataProvider>
  );

};

export default LegalPageContainer;
